import React from 'react';
import _ from 'lodash';

import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import {default as Modal, withModal} from 'components/Modal';
import {
  MODALS,
  removeGocardlessInvitation,
  fetchGocardlessCustomerAndInvitation
} from 'ducks/tenancy';

import './styles.css';

class RemoveGocardlessInvitationModal extends React.Component<any> {
  componentDidMount() {
    const {tenancyId} = this.props;

    this.props.fetchGocardlessCustomerAndInvitation(
      {tenancyId},
      this.props.storeDataExtraActions(data => ({
        canBeVoided: _.get(data, 'currentGocardlessInvitation.canBeVoided')
      }))
    );
  }

  removeInvitation = () => {
    const {tenancyId, data: {invitationId}} = this.props;

    const successExtraActions = [
      ...this.props.closeModalExtraActions,
      () => fetchGocardlessCustomerAndInvitation({tenancyId})
    ];

    const failureExtraActions = this.props.storeDataExtraActions(errors => ({
      errors
    }));

    this.props.removeGocardlessInvitation(
      {tenancyId, invitationId, voidInvitation: false},
      successExtraActions,
      failureExtraActions
    );
  };

  removeAndVoidInvitation = () => {
    const {invitationId} = this.props.data;

    this.props.openRemoveAndVoidGocardlessInvitationModal(invitationId);
  };

  render() {
    const {errors, canBeVoided} = this.props.data;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="RemoveGocardlessInvitationModal"
        type={Modal.SUB_MEDIUM}>
        <Modal.Header>
          <h3 className="heading">Remove Invitation from Booking</h3>
        </Modal.Header>
        <Modal.Body>
          {errors && <ErrorBlock>{errors._error}</ErrorBlock>}
          Would you like to void this invite so it can no longer be completed by
          the customer or used with other bookings?
        </Modal.Body>
        <Modal.Footer>
          <Button blue onClick={this.removeInvitation}>
            No, just remove
          </Button>
          <Button
            red
            onClick={this.removeAndVoidInvitation}
            disabled={!canBeVoided}>
            Void invitation
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});
const mapDispatchToModalProps = {
  removeGocardlessInvitation,
  fetchGocardlessCustomerAndInvitation
};

export default withModal(
  MODALS.REMOVE_GOCARDLESS_INVITATION,
  mapStateToModalData,
  mapDispatchToModalProps
)(RemoveGocardlessInvitationModal);
